/**
 * Konta uzytkownikow Autorud — production schema z fixed dataset dla wczesnego pilotu.
 * Faza 1 zastapi storage Better Auth + user_claims z bazy (UUID-y identyczne).
 */

export type Role = 'admin' | 'director' | 'manager' | 'advisor';

export type Scope =
  | { kind: 'dealer'; value: string }
  | { kind: 'brand'; value: string }
  | { kind: 'branch'; value: string };

export type DemoAccount = {
  id: string;
  email: string;
  password: string;
  fullName: string;
  role: Role;
  roleLabel: string;
  scope: Scope;
  branchPrimary: string;
  brandPrimary?: string;
  hint: string;
};

export const demoAccounts: DemoAccount[] = [
  {
    id: 'u-hubert',
    email: 'office@domoresoft.com',
    password: 'demo',
    fullName: 'Hubert Ptaszek',
    role: 'admin',
    roleLabel: 'Administrator',
    scope: { kind: 'dealer', value: 'Autorud' },
    branchPrimary: 'Cupra Kielce',
    hint: 'Pelne uprawnienia + audit log',
  },
  {
    id: 'u-dyrektor',
    email: 'dyrektor@autorud.domoresoft.com',
    password: 'demo',
    fullName: 'Dyrektor Sprzedazy',
    role: 'director',
    roleLabel: 'Dyrektor sprzedazy',
    scope: { kind: 'dealer', value: 'Autorud' },
    branchPrimary: 'Cupra Kielce',
    hint: 'Cala grupa Autorud — 7 oddzialow, 4 marki',
  },
  {
    id: 'u-kierownik-cupra',
    email: 'kierownik.cupra@autorud.domoresoft.com',
    password: 'demo',
    fullName: 'Kierownik Cupra',
    role: 'manager',
    roleLabel: 'Kierownik sprzedazy Cupra',
    scope: { kind: 'brand', value: 'Cupra' },
    branchPrimary: 'Cupra Kielce',
    brandPrimary: 'Cupra',
    hint: 'Cupra Kielce + Cupra Radom',
  },
  {
    id: 'u-kierownik-audi',
    email: 'kierownik.audi@autorud.domoresoft.com',
    password: 'demo',
    fullName: 'Kierownik Audi Kielce',
    role: 'manager',
    roleLabel: 'Kierownik oddzialu',
    scope: { kind: 'branch', value: 'Audi Kielce' },
    branchPrimary: 'Audi Kielce',
    brandPrimary: 'Audi',
    hint: 'Oddzial Audi Kielce',
  },
  {
    id: 'u-doradca',
    email: 'doradca.pierwszy@autorud.domoresoft.com',
    password: 'demo',
    fullName: 'Doradca Pierwszy',
    role: 'advisor',
    roleLabel: 'Doradca sprzedazy',
    scope: { kind: 'branch', value: 'Cupra Kielce' },
    branchPrimary: 'Cupra Kielce',
    brandPrimary: 'Cupra',
    hint: 'Tylko wlasne leady i sprzedaze',
  },
];

export function findAccount(email: string, password: string): DemoAccount | null {
  return (
    demoAccounts.find(
      (a) => a.email.toLowerCase() === email.toLowerCase() && a.password === password,
    ) ?? null
  );
}

export function findById(id: string): DemoAccount | null {
  return demoAccounts.find((a) => a.id === id) ?? null;
}

export function canSee(
  user: DemoAccount,
  item: { brand?: string; branch?: string; advisorName?: string },
): boolean {
  if (user.role === 'admin' || user.role === 'director') return true;

  if (user.role === 'manager' && user.scope.kind === 'brand') {
    return item.brand === user.scope.value;
  }

  if (user.role === 'manager' && user.scope.kind === 'branch') {
    return item.branch === user.scope.value;
  }

  if (user.role === 'advisor') {
    return item.advisorName === user.fullName;
  }

  return false;
}
